import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';

import * as Config from '../../../../config.json';
import styles from '../../../css/paymentPage/subComponents/SquareGiftCardComponent.scss';

const pageStyles = typeof styles === 'function' ? styles() : styles;

class SquareGiftCardComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorMessages: [],
    };
  }

  cardNonceResponseReceived = (errors, nonce, cardData) => {
    const { user } = this.props;
    if (errors) {
      this.setState({ errorMessages: errors.map(error => error.message) });
      return;
    }

    this.setState({ errorMessages: [] });
    const newCard = {
      name: user.name,
      cardNumber: nonce,
      expiryDate: `${cardData.exp_month}${cardData.exp_year}`,
      cardType: cardData.card_brand.includes('GIFT_CARD') ? 'GIFT_CARD' : null,
    };

    this.addCard(newCard);
  }

  addCard = async (newCard) => {
    const { user, actions } = this.props;

    const paymentMethod = {
      name: newCard.name,
      cardNumber: newCard.cardNumber,
      expiryMonth: newCard.expiryDate.slice(0, 2),
      expiryYear: newCard.expiryDate.slice(2),
    };

    const newCardResponse = await actions
      .addResource(
        user.token, paymentMethod,
        'users', user.id,
        'payment_options',
      );
    if (!newCardResponse || newCardResponse.error) {
      console.log('There was an error adding your giftcard', newCardResponse.error);
    }
  }

  render() {
    const { translation, currentOrder } = this.props;
    return (
      <div style={pageStyles.formContainer}>
        <form id="payment-form">
        <div id="gift-card-container"></div>
        <button id="gift-card-button" type="button">Pay with Gift Card</button>

        <div id="card-container"></div>
        <button id="card-button" type="button">Pay $1.00</button>
        </form>
        <div id="payment-status-container"></div>

        <div className="sq-error-message">
          {
            this.state.errorMessages.map(errorMessage =>
              <li key={`sq-error-${errorMessage}`}>{errorMessage}</li>)
          }
        </div>
      </div>
    );
  }
}

SquareGiftCardComponent.propTypes = {
  translation: PropTypes.func.isRequired,
  user: PropTypes.objectOf(PropTypes.any).isRequired,
  actions: PropTypes.objectOf(PropTypes.func).isRequired,
  currentOrder: PropTypes.objectOf(PropTypes.any).isRequired,
};

export default withStyles(styles)(SquareGiftCardComponent);
